//libs
import { useEffect } from "react";
import { DialogTitle } from "@headlessui/react";
//components
import Button from "components/Button";
import ModalDialog from "components/ModalDialog";
import Loading from "components/Loading";
//hooks
import Message from "components/Message";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {
  useAddQuotationDocument,
  useAddTenderDocument,
  useDocumentTypes,
} from "hooks/api/useDocuments";

const allowedExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".docx",
  ".xlsx",
  ".pdf",
  ".doc",
];

// function isValidFileType(fileName) {
//   console.log({ fileName });
//   return fileName && allowedExtensions.indexOf(fileName.split(".").pop()) > -1;
// }

const schema = yup.object({
  documentType: yup.string().required("Document Type is required"),
  documentFile: yup.mixed().required("File is require"),
  // documentFile: yup
  //   .mixed()
  //   .required("Document file is required")
  //   .test("is-valid-type", "Invalid File Type", (value) =>
  //     isValidFileType(value && value.name.toLowerCase())
  //   ),
  comment: yup.string(),
});
// image: Yup
//     .mixed()
//     .required("Required")
//     .test("is-valid-type", "Not a valid image type",
//       value => isValidFileType(value && value.name.toLowerCase(), "image"))
//     .test("is-valid-size", "Max allowed size is 100KB",
//       value => value && value.size <= MAX_FILE_SIZE)
// }

export default function AddNewTenderDocumentModal({
  isTender,
  tenderId,
  open,
  setOpen,
}) {
  const { data } = useDocumentTypes();
  const useAddDocument = isTender
    ? useAddTenderDocument
    : useAddQuotationDocument;
  const { mutate, isPending } = useAddDocument(tenderId);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (data?.data?.length > 0) {
      setValue("documentType", data.data[0].name);
    }
  }, [data?.data, setValue]);

  const onSubmit = (values) => {
    try {
      const formData = new FormData();
      formData.append("document_type", values.documentType);
      formData.append("document", values.documentFile[0]);
      formData.append("comment", values.comment);
      mutate(formData);
      setOpen(false);
    } catch (err) {}
  };

  // const handleFileChange = (e) => {
  //   console.log("called handle filechange");
  //   const file = e.target.files[0];
  //   console.log({ file });
  //   if (file) {
  //     setValue("documentFile", file);
  //   }
  // };

  if (isPending) return <></>;
  return (
    <ModalDialog open={open} setOpen={setOpen}>
      <div className="space-y-4">
        <DialogTitle
          as="h3"
          className="text-base font-semibold leading-6 text-gray-900"
        >
          Add New {isTender ? "Tender" : "Quotation"} Document
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="">
            <label
              htmlFor="documentType"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Document Type
            </label>
            <div className="mt-2">
              <select
                id="documentType"
                name="documentType"
                autoComplete="off"
                {...register("documentType")}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-purple-600 sm:max-w-xs sm:text-sm sm:leading-6"
              >
                {data?.data?.map((type) => (
                  <option key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
              </select>
              <Message message={errors.documentType?.message} />
            </div>
          </div>
          <div className="">
            <label
              htmlFor="documentFile"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Documents
            </label>
            <div className="mt-2">
              <input
                id="documentFile"
                name="documentFile"
                type="file"
                autoComplete="off"
                {...register("documentFile")}
                // value={tenderFeesReceipt}
                // handleChange={handleFileChange}
                accept={allowedExtensions}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-purple-600 sm:text-sm sm:leading-6"
              />
            </div>
            <Message message={""} />
          </div>
          <div className="">
            <label
              htmlFor="comment"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Comment 
            </label>
            <div className="mt-2">
              <input
                id="comment"
                name="comment"
                type="text"
                autoComplete="off"
                {...register("comment")}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-purple-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div className="sm:flex gap-2">
            <Button disabled={isPending} type="submit">
              <Loading text="Add" isLoading={isPending} />
            </Button>
            {/* <button
              disabled={isPending}
              type="button"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
            >
              <Loading text="Add And Another" isLoading={isPending} />
            </button> */}
            <button
              type="button"
              data-autofocus
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </ModalDialog>
  );
}
